module.exports = __webpack_public_path__ + "static/img/title-en.37b24a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/title-en.png
// module id = k84L
// module chunks = 1